import React from "react";

import { MainStateContext, MainDispatchContext } from "./index";
import { actions } from "./store";

function useMainState() {
  return React.useContext(MainStateContext);
}

function useMain() {
  return actions(React.useContext(MainDispatchContext));
}

export { useMain, useMainState };
